<template>
  <filter-modal
    @validate="$emit('validate', [...innerChecked])"
    @close="$emit('close')"
    :title="$t('components.modals.theme.title')"
  >
    <p class="mb-6">{{ $t("components.modals.theme.text") }}</p>
    <div class="flex theme-grid flex-wrap justify-center gap-1 overflow-y-auto">
      <div
        v-for="theme in themes"
        :key="theme.id"
        :class="{ checked: innerChecked.has(theme.id) }"
        @click="onChange(theme)"
        class="theme flex flex-col justify-center text-interaction-dark gap-1 p-1 leading-none rounded-md border-interaction-light overflow-hidden"
      >
        <vote-topic-icon :topic="theme" class="h-10" />
        <span
          class="text-center overflow-hidden text-color-regular text-base"
          style="hyphens: auto;"
          >{{ theme.name }}</span
        >
      </div>
    </div>
  </filter-modal>
</template>

<script>
import FilterModal from "./FilterModal.vue";
import VoteTopicIcon from "../vote/VoteTopicIcon.vue";

export default {
  name: "ThemeFilterModal",
  components: {
    FilterModal,
    VoteTopicIcon
  },
  data() {
    return {
      innerChecked: new Set()
    };
  },
  created() {
    this.innerChecked = new Set(this.checked);
  },
  watch: {
    checked(newValue) {
      this.innerChecked = new Set(newValue);
    }
  },
  props: {
    checked: {
      type: Array
    },
    themes: {
      type: Array
    }
  },
  methods: {
    onChange(theme) {
      const innerCheckedCopy = new Set(this.innerChecked);
      if (this.innerChecked.has(theme.id)) {
        innerCheckedCopy.delete(theme.id);
      } else {
        innerCheckedCopy.add(theme.id);
      }
      this.innerChecked = innerCheckedCopy;
    }
  }
};
</script>

<style scoped>
.theme {
  width: 6.5rem;
  height: 6.5rem;
  cursor: pointer;
  border-width: 0.125rem;
}

.theme-grid {
  margin: 0 -1rem;
}

.checked {
  background-color: var(--interaction-light);
  color: var(--color-regular);
  font-weight: bold;
}
</style>
